import React, { useEffect, useMemo, useState } from "react"
import withRouter from "components/Common/withRouter"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import toast from "react-hot-toast"
import {
  navigationHistory,
  navigationTemplateStauts,
  updateHomePage,
  viewHomePage,
} from "helpers/fakebackend_helper"
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput"
import ImagePopup from "pages/Home-Page/ImagePopup"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Spinners from "components/Common/Spinner"
import TableContainer from "components/Common/TableContainer"
import moment from "moment/moment"

const ActCodesList = () => {
  const [navId, setNavId] = useState()
  const [slug, setSlug] = useState()
  const { state } = useLocation()
  const [isLoading, setisLoading] = useState(false)
  const [list, setList] = useState([])

  const [permission, setPermission] = useState({})

  const getTemplete = navigation_id => {
    // let payload = new FormData()
    // payload.append('navigation_slug', navigation_id)
    let payload = {}

    if (navigation_id) {
      payload.slug = navigation_id
    } else {
      payload.slug = state?.data?.slug
    }

    const UserPer = JSON.parse(localStorage.getItem("authUser"))
    let finder = UserPer?.admin?.admin_permissions?.find(
      i => i?.slug == state?.data?.slug
    )

    navigationHistory(payload)
      .then(res => {
        let temp = []

        res?.map((item, ind) => {
          let obj = { ...item }

          obj.is_approver = finder?.is_approver

          if (item?.template_type == 1) {
            obj.type = "home"
          } else if (item?.template_type == 2) {
            obj.type = "About us"
          } else if (item?.template_type == 3) {
            obj.type = "Directorate"
          } else if (item?.template_type == 4) {
            obj.type = "Magazine"
          } else if (item?.template_type == 5) {
            obj.type = "Ennum Ezhuthum"
          } else if (item?.template_type == 6) {
            obj.type = "RTE"
          } else if (item?.template_type == 7) {
            obj.type = "Act and Codes"
          } else if (item?.template_type == 8) {
            obj.type = "GOS"
          } else if (item?.template_type == 9) {
            obj.type = "Press Release"
          }
          temp.push(obj)
        })
        // console.log('temp',temp);

        setList(temp)
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    if (state?.data) {
      setNavId(state?.data?.id)
      getTemplete(state?.data?.slug)
      setSlug(state?.data?.slug)
    }
  }, [state])

  useEffect(() => {
    if (slug) {
      getTemplete(slug)
    }
  }, [slug])

  //   console.log('statestatestate', slug);

  const handleStatus = status => {
      let payload = {
        navigation_template_id: status,
      }
      navigationTemplateStauts(payload)
        .then(res => {
          if (res?.success) {
            getTemplete(slug)
            toast.success(res?.message ?? "Status Updated")
          } else {
            toast.error(res?.message ?? "somthing went wrong!")
          }
        })
        .catch(err => {
          console.log("err", err)
        })
  }

  const columns = useMemo(
    () => [
      {
        header: "SNO",
        accessorKey: "admin_id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell, row) => {
          return (
            <>
              <h5 className="font-size-14 mb-1">{cell.row.index + 1}</h5>
            </>
          )
        },
      },
      {
        header: "Type",
        accessorKey: "type",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: "Modified By",
        accessorKey: "modified_by",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: "Updated At",
        accessorKey: "updated_at",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <>
              <p className="text-muted mb-0">
                {moment(cell.row.original.updated_at).format("DD-MM-YYYY")}
              </p>
            </>
          )
        },
      },

      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <div>
              {cell.getValue() ? (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => handleStatus(cell.row.original?.id)}
                  disabled={cell.row.original?.is_approver ? false : true}
                >
                  Active
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={cell.row.original?.is_approver ? false : true}
                  onClick={() => handleStatus(cell.row.original?.id)}
                >
                  Disable
                </button>
              )}
            </div>
          )
        },
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to={`/template/act/${cellProps.row.original.id}`}
                state={{ data: cellProps.row.original }}
                className="text-primary"
              >
                <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  const handleNewClicks = () => {
    router("/create-admin")
  }

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title=""
              breadcrumbItem={`${slug?.toUpperCase()} LIST`}
            />
            <Row>
              {isLoading ? (
                <Spinners setLoading={setisLoading} />
              ) : (
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={list || []}
                        // isGlobalFilter={true}
                        isPagination={true}
                        // SearchPlaceholder="Search..."
                        isCustomPageSize={true}
                        tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
              )}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </>
  )
}

export default withRouter(ActCodesList)
